import { useState } from "react";
import { Link } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { adminAuth } from "@/lib/adminAuth";
import { BrandHeader } from "@/components/BrandHeader";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  const request = useMutation({
    mutationFn: () => adminAuth.forgotPassword(email),
    onSuccess: (r) => { setMessage(r.message); setError(null); },
    onError: (e: any) => setError(e?.response?.data?.detail ?? "Request failed. Try again in a moment."),
  });

  return (
    <>
      <BrandHeader />
      <main className="grid min-h-[calc(100vh-80px)] place-items-center bg-brand-light p-6">
        <form className="card w-full max-w-sm p-8"
          onSubmit={(e) => { e.preventDefault(); request.mutate(); }}>
          <h1 className="text-2xl font-bold text-brand">Forgot password?</h1>
          <p className="mt-1 text-sm text-brand-ink/70">
            Enter the email you use to sign in. We'll send a reset link if the account exists.
          </p>

          <label className="field-label mt-6" htmlFor="email">Email</label>
          <input id="email" type="email" required autoComplete="username"
            className="field-input" value={email} onChange={(e) => setEmail(e.target.value)} />

          {message && (
            <div className="mt-4 rounded-lg bg-emerald-50 p-3 text-sm text-emerald-800">
              {message}
            </div>
          )}
          {error && <div className="mt-4 text-sm text-brand" role="alert">{error}</div>}

          <button type="submit" className="btn-primary mt-6 w-full justify-center"
            disabled={request.isPending || !!message}>
            {request.isPending ? "Sending…" : message ? "Sent" : "Send reset link"}
          </button>

          <div className="mt-4 text-center text-sm">
            <Link to="/admin/login" className="text-brand hover:underline">← Back to sign in</Link>
          </div>
        </form>
      </main>
    </>
  );
}
